import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storageSub= new Subject<String>();
  
  constructor() {}
  public saveData(key: string, value: string) {
    if (typeof localStorage === 'undefined') { return; }
    localStorage.setItem(key, value);
    this.storageSub.next('changed');
  }

  public getData(key: string) {
    if (typeof localStorage === 'undefined') { return null; }
    return localStorage.getItem(key);
  }
  public removeData(key: string) {
    if (typeof localStorage === 'undefined') { return; }
    localStorage.removeItem(key);
    this.storageSub.next('changed');
  }

  public clearData() {
    if (typeof localStorage === 'undefined') { return; }
    localStorage.clear();
  }

  public watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }
  
}
